import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CampaignCreationWizard } from "@/components/campaign-creation/CampaignCreationWizard";
import { requireModule } from "@/lib/module-access";

export const Route = createFileRoute("/_authed/campaigns/new")({
  beforeLoad: () => {
    requireModule("campaigns");
  },
  // ADP-137: the portfolio detail's「新建广告活动」entry pre-selects the
  // portfolio's shop and portfolio. Invalid values degrade to a plain open.
  validateSearch: z.object({
    shopId: z.string().uuid().optional().catch(undefined),
    portfolioId: z.string().uuid().optional().catch(undefined),
  }),
  component: CampaignCreationWizard,
});
